import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <h3>Designed by Laleh Koupaei</h3>
    </footer>
  );
}

export default Footer;
